import { ApiError } from "../../api-backend";

const HTTP_STATUS_FAILED_DEPENDENCY = 424;
const MAX_RETRIES = 3;

export const shouldRetryPayment = (
  failureCount: number,
  error: unknown,
): boolean => {
  if (failureCount >= MAX_RETRIES) return false;
  if (
    error instanceof ApiError &&
    error.status === HTTP_STATUS_FAILED_DEPENDENCY
  )
    return false;
  return true;
};
